import React, { createContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const languages = {
    pt: {
        language: "pt",
        language_pt: "Português",
        language_en: "Inglês",
        language_sigla: "PT-BR",
        language_active: "Português",
        language_pt_inverse: "Português",
        language_en_inverse: "English",
        menu_home: "Home",
        menu_about: "Sobre o Evento",
        menu_news: "Novidades",
        menu_agenda: "Programação",
        menu_agenda_of: "Agenda de",
        menu_local: "Local",
        menu_panel: "Painelistas",
        menu_inscricao: "Inscreva-se",
        menu_sub_inscricao: "Inscrição Convidados",
        menu_sub_inscricao_imprensa: "Inscrição Imprensa",
        menu_imprensa: "Imprensa",
        menu_imprensa_press: "Press Release",
        menu_imprensa_material: "Matérias",
        menu_eventos: "Eventos Paralelos",
        menu_edicao: "Edições Anteriores",
        menu_contato: "Fale Conosco",
        menu_events: "Eventos",
        mais_info: "Mais informações e participação em breve.",
        agenda_btn: "AGENDA PRELIMINAR",
        desenvolvido: "Desenvolvido por",
        site_name: "Crianças e ação climática: prioridades e compromissos rumo à COP30",
        name: "Nome Completo",
        email: "E-mail",
        password: "Crie sua Senha",
        just_password: "Senha",
        organization: "Organização / Instituição que representa",
        organization_sector: "Setor ao qual pertence a organização/instituição",
        sector_1: "Academia / Pesquisa / Universidade",
        sector_2: "Embaixada",
        sector_3: "Estudante / Jovem liderança",
        sector_4: "Executivo Estadual",
        sector_5: "Executivo Federal",
        sector_6: "Executivo Municipal",
        sector_7: "Judiciário",
        sector_8: "Legislativo Estadual",
        sector_9: "Legislativo Federal",
        sector_10: "Legislativo Municipal",
        sector_11: "Organismo internacional",
        sector_12: "Organização da sociedade civil",
        sector_13: "Setor privado",
        sector_14: "Acompanhante de criança ou adolescente",
        sector_15: "Outro",
        sector_other: "Especificar",
        sector_area: "Setor área ou temática principal da sua organização/instituição",
        sector_area_1: "Educação",
        sector_area_2: "Direito das crianças e adolescentes",
        sector_area_3: "Clima, natureza, meio ambiente",
        sector_area_4: "Bem estar e desenvolvimento infantil",
        sector_area_5: "Cidades",
        sector_area_6: "Comunicação",
        sector_area_7: "Outro",
        state: "Estado",
        city: "Município",
        office: "Cargo ou função",
        age: "Idade",
        race: "Com qual categoria de raça ou etnia você mais se identifica?",
        genre: "Qual é sua identidade de gênero?",
        phone: "Telefone (WhatsApp)",
        disability: "Você precisa de algum recurso de acessibilidade para participar do evento?",
        food: "Restrição Alimentar",
        type: "Como você pretende participar do evento",
        medium: "Veículo/ meio de comunicação",
        presencial: "Presencial",
        online: "Online",
        select: "Em relação aos painéis que teremos no dia 27/05, selecione abaixo quais você tem a intenção de participar",
        send: "ENVIAR",
        update: "ATUALIZAR",
        pre_inscricao: "PRÉ-INSCRIÇÃO",
        inscricao: "INSCRIÇÃO",
        error_input: "Preencha todos os campos obrigatórios!",
        error_type: "Preencha o Tipo de Participação!",
        success: "Informações enviadas com sucesso! Retornaremos no e-mail inscrito.",
        error_email: "E-mail já está sendo usado por outra conta!",
        email_error: "INSCRIÇÃO NÃO EFETUADA por divergência de informações. Favor checar o e-mail digitado.",
        enter: "ACESSAR",
        error_login: "Erro ao fazer login!",
        error_input_email: "Preencha o campo E-mail!",
        error_input_senha: "Preencha o campo Senha!",
        error_incorrect: "E-mail ou senha incorretos!",
        login_title: "Acessar o Evento",
        select_watch: "Selecione o Evento que deseja assistir",
        error_select: "Selecione pelo menos um Evento!",
        error_found: "Código não encontrado!",
        code: "Código",
        hello: "Olá",
        logout: "Sair",
        back: "Voltar",
        yes: "Sim",
        no: "Não",
        not_comment: "Nenhum comentário encontrado.",
        write_comment: "Escreva seu comentário...",
        send_comment: "ENVIAR COMENTÁRIO",
        menu_watch: "Assista Aqui",
        click_here: "Clique Aqui",
        ended_online: "Inscrição apenas disponível para participação On-line",
        ended: "Inscrições presenciais encerradas",
        intend: "Você tem a intenção de participar",
        menu_day_26: "Dia 26/05",
        menu_day_27: "Dia 27/05",
        menu_imprensa_press_26: "Release - 26/05",
        menu_imprensa_press_27: "Release - 27/05",
        accept: "Ao participar do evento você autoriza a organização a utilizar sua imagem, bem como seus áudios e vídeos que porventura forem captados.",
        aware: "Estou ciente do uso dos meus dados pessoais para o propósito descrito acima.",
    },
    en: {
        language: "en",
        language_pt: "Portuguese",
        language_en: "English",
        language_sigla: "EN",
        language_active: "English",
        language_pt_inverse: "Português",
        language_en_inverse: "English",
        menu_home: "Home",
        menu_about: "About the Event",
        menu_news: "News",
        menu_agenda: "Schedule",
        menu_agenda_of: "Calendar of",
        menu_local: "Location",
        menu_panel: "Panelists",
        menu_inscricao: "Registration",
        menu_sub_inscricao: "Guest Registration",
        menu_sub_inscricao_imprensa: "Press Registration",
        menu_imprensa: "Press",
        menu_imprensa_press: "Press Release",
        menu_imprensa_material: "Articles",
        menu_eventos: "Side Events",
        menu_edicao: "Previous Editions",
        menu_contato: "Contact",
        menu_events: "Events",
        mais_info: "More info and participation soon.",
        agenda_btn: "PRELIMINARY AGENDA",
        desenvolvido: "Developed by",
        site_name: "Children and Climate Action: Priorities and Commitments Towards COP30",
        name: "Full Name",
        email: "Email",
        password: "Create your Password",
        just_password: "Password",
        organization: "Organization / Institution you represent",
        organization_sector: "Sector to which the organization/institution belongs",
        sector_1: "Academia / Research Institution / University",
        sector_2: "Embassy",
        sector_3: "Student / Young Leader",
        sector_4: "State Executive Power",
        sector_5: "Federal Executive Power",
        sector_6: "Municipal Executive Power",
        sector_7: "Judiciary",
        sector_8: "State Legislative",
        sector_9: "Federal Legislative",
        sector_10: "Municipal Legislative",
        sector_11: "International Body",
        sector_12: "Civil Society Organization",
        sector_13: "Private Sector",
        sector_14: "Companion of child or adolescent",
        sector_15: "Other",
        sector_other: "Specify",
        sector_area: "Main area or theme of your organization/institution",
        sector_area_1: "Education",
        sector_area_2: "Rights of children and adolescents",
        sector_area_3: "Climate, nature and Environment",
        sector_area_4: "Children's well-being and development",
        sector_area_5: "Cities",
        sector_area_6: "Communication",
        sector_area_7: "Other",
        state: "State",
        city: "City",
        office: "Office",
        age: "Age",
        race: "What race or ethnicity do you identify with?",
        genre: "What is your gender identity?",
        phone: "Telephone Number (WhatsApp)",
        disability: "Do you need any accessibility features to participate in the event?",
        food: "Food Restriction",
        type: "How do you plan to participate in the event",
        medium: "Communication media",
        presencial: "In person",
        online: "Online",
        select: "Regarding the panels scheduled for May 27th, select below the ones you wish to attend",
        send: "SUBMIT",
        update: "UPDATE",
        pre_inscricao: "PRE-REGISTRATION",
        inscricao: "ENROLLMENT",
        error_input: "Fill in all mandatory fields!",
        error_type: "Fill in the type of participation!",
        success: "Information sent successfully! We will get back to you at the email address you provided.",
        error_email: "Email is already being used by another account!",
        email_error: "REGISTRATION NOT COMPLETED due to conflicting information. Please check the email address entered.",
        enter: "ACCESS",
        error_login: "Error when logging in!",
        error_input_email: "Fill in the email field!",
        error_input_senha: "Fill in the password field!",
        error_incorrect: "Incorrect email or password!",
        login_title: "Access the Event",
        select_watch: "Select the event you want to watch",
        error_select: "Select at least one Event!",
        error_found: "Code not found!",
        code: "Code",
        hello: "Hello",
        logout: "Logout",
        back: "Back",
        yes: "Yes",
        no: "No",
        not_comment: "No comments found.",
        write_comment: "Write your comment ...",
        send_comment: "SEND COMMENT",
        menu_watch: "Watch Here",
        click_here: "Click Here",
        ended_online: "Registration only available for Online participation",
        ended: "In-person registrations closed",
        intend: "Do you intend to participate",
        menu_day_26: "May 26",
        menu_day_27: "May 27",
        menu_imprensa_press_26: "Release - May 26",
        menu_imprensa_press_27: "Release - May 27",
        accept: "By participating in the event, you authorize the organization to use your image, as well as any audio and video recording that may be captured.",
        aware: "I am aware of the use of my personal data for the purpose described above.",
    }
}

export const LanguageProvider = ({ children }) => {
    
    const [language, setLanguage] = useState({});

    async function loadStorage() {
        const storageLanguage = localStorage.getItem('language');
        const hostname = window.location.hostname;
        if (!storageLanguage) {
            let defaultLanguage = 'pt';
            if (hostname.includes('children-and-climate-action.com')) {
                defaultLanguage = 'en';
            } else if (hostname.includes('criancas-e-acao-climatica.com.br')) {
                defaultLanguage = 'pt';
            }
            setLanguageStore(defaultLanguage);
        }else{
            setLanguageStore(storageLanguage);
        }
    }

    async function setStorage(lang) {
        localStorage.setItem('language', lang);
    }

    function setLanguageStore(lang){
        if(lang==="pt" || lang==="PT"){
            setLanguage(languages.pt);
            setStorage("pt");
        }else{
            setLanguage(languages.en);
            setStorage("en");
        }
    }

    useEffect(() => {
        loadStorage();
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, setLanguageStore }} >
            {children}
        </LanguageContext.Provider>
    )

}

export default LanguageContext;